export enum RendererModes {
  WebGL = 'webgl',
  WebGL2 = 'webgl2'
}
